import { english } from './english';

export const AppDictionaries = {
    english,
};
